<template>
<div>
    <!-- nav -->
    <header-bar></header-bar>
    <!-- body -->
    <div class="container-fluid full-content page">
        <!-- swiper -->
        <swiper-bar :swiperItem="swiperItem"></swiper-bar>
        <!-- 首页会员 -->
        <div class="container boss-journal">
            <div class="boss-vip clearfix">
                <h4>
                    酝智文化传媒会员
                </h4>
                <div class="row">
                    <div class="col-md-3 journal-info">
                        <a href="http://b.1.7cong.cn/#/" target="_blank" style="display: block;"><img src="/static/boss_01.png"> <span>全面刊期即时信息查询系统</span></a>
                    </div>
                    <div class="col-md-3 journal-info">
                        <a href="http://b.1.7cong.cn/#/" target="_blank" style="display: block;"><img src="/static/boss_02.png"> <span>打折促销及时掌握</span></a>
                    </div>
                    <div class="col-md-3 journal-info">
                        <a href="http://b.1.7cong.cn/#/" target="_blank" style="display: block;"><img src="/static/boss_03.png"> <span>最低成本自助投稿 无需中间商</span></a>
                    </div>
                    <div class="col-md-3 journal-info">
                        <a href="http://b.1.7cong.cn/#/" target="_blank" style="display: block;"><img src="/static/boss_04.png"> <span>丰富的售后问题解决方案</span></a>
                    </div>
                </div>
            </div>
            
            <div class="journal-box">
                <h4>
                    期刊信息整合平台
                </h4>
                <p>
                    打破传统的革命性学术科研平台，我们收集学术期刊信息，并为客户提供各种优质的学术服务
                </p>
                <div class="journal-pro">
                    <div class="journal-product">
                        <h5>
                            期刊查询系统
                        </h5><img src="/static/journal_01.png"> <span>海量期刊资源库，更多的发表渠道</span>
                        <p>
                            精致的图文信息介绍，告别纯文本说明
                        </p><a href="http://b.1.7cong.cn/#/" target="_blank">了解更多+</a>
                    </div>
                    <div class="journal-product">
                        <h5>
                            预审稿系统
                        </h5><img src="/static/journal_02.png"> <span>专业编辑，“荐”无虚发</span>
                        <p>
                            有效提高命中率，实现投稿最优解
                        </p><a href="javascript:;">了解更多+</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- 知识产权 -->
        <div class="patent">
            <h4>
                知识产权服务
            </h4>
            <p>
                知识产权 不需如此高成本
            </p>
            <div class="container patent-container">
                <div class="row patent-pro clearfix">
                    <div class="col-md-4 journal-no-margin">
                        <img src="/static/patent_01.png">
                        <h5>
                            专利申请
                        </h5>
                        <p>
                            完善的服务和流程<br>
                            一对一专业顾问全程答疑<br>
                            价格超低
                        </p><a href="javascript:;" class="intellectual">了解更多+</a>
                    </div>
                    <div class="col-md-4 journal-no-margin">
                        <img src="/static/patent_02.png">
                        <h5>
                            版权服务
                        </h5>
                        <p>
                            操作极简<br>
                            无需高成本即可拿证
                        </p><a href="javascript:;" class="intellectual">了解更多+</a>
                    </div>
                    <div class="col-md-4 journal-no-margin">
                        <img src="/static/patent_03.png">
                        <h5>
                            商标服务
                        </h5>
                        <p>
                            海量资源<br>
                            价格透明<br>
                            质量保障
                        </p><a href="javascript:;" class="intellectual">了解更多+</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- 教材 -->
        <div class="container publish">
            <h4>
                教材专著出版
            </h4>
            <p>
                专业职称信息服务平台，专注职称咨询、出版专著、教材和挂编等业务，可根据客户需求提供精准服务，确保正规出版
            </p>
            <div class="row publish-pro clearfix">
                <div class="col-md-6 publish-img">
                    <img src="/static/publish_01.png">
                </div>
                <div class="col-md-6">
                    <div class="row publish-full">
                        <div class="col-md-6 publish-book">
                            <h5>
                                出版书籍
                            </h5>
                            <p>
                                正规出版可查询<br>
                                1V1专业服务体系
                            </p><a href="http://b.1.7cong.cn/#/">了解更多+</a>
                        </div>
                        <div class="col-md-6 publish-right-marks">
                            <img src="/static/publish_03.png">
                            <p>
                                酝智文化传媒的出版, 不黄稿<br>
                                优先保证合作商利益<br>
                                不以单方面盈利为第一目的
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row publish-full">
                        <div class="col-md-6 publish-left-marks">
                            <img src="/static/publish_04.png">
                            <p>
                                一件也是代理价,独特代理机制<br>
                                相信酝智文化传媒的都是战略伙伴<br>
                                享受最低优惠
                            </p>
                        </div>
                        <div class="col-md-6 publish-book">
                            <h5>
                                著作挂名
                            </h5>
                            <p>
                                全科覆盖<br>
                                价低，极速
                            </p><a href="http://b.1.7cong.cn/#/">了解更多+</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 publish-img">
                    <img src="/static/publish_02.png">
                </div>
            </div>
        </div>
    </div>
    <footerBar></footerBar>
</div>
</template>

<script>
import $C from "@/common/config.js"
import swiperBar from './swiper/Swiper'
import headerBar from './header/Header'
import footerBar from './footer/Footer'
export default {
  name: 'Index',
  components: {
    swiperBar,
    headerBar,
    footerBar
  },
  data () {
    return {
        swiperItem:[
            {
                img:"/static/banner_02.png",
                title:"知识产权，点击咨询客服"
            },
            {
                img:"/static/banner_01.png",
                title:"知识产权，点击咨询客服"
            },
            {
                img:"/static/banner_03.png",
                title:"知识产权，点击咨询客服"
            }
        ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Index.vue